import { cva } from 'class-variance-authority';

export const iconWrapperStyles = cva(
  ['rounded-8 shape-auto text-auto fill-charcoal-500 flex items-center justify-center'],
  {
    variants: {
      spacing: {
        none: 'p-0',
        small: 'rounded-md p-1',
        medium: 'rounded-md p-2'
      },
      size: {
        xxxsmall: 'min-h-1 min-w-1',
        xxsmall: 'min-h-2 min-w-2',
        xsmall: 'min-h-1-5 min-w-1-5',
        small: 'min-h-3 min-w-3',
        medium: 'min-h-4 min-w-4',
        large: 'min-h-5 min-w-5',
        xlarge: 'min-h-8 min-w-8',
        xxlarge: 'min-h-16 min-w-16'
      }
    },
    defaultVariants: {
      spacing: 'none',
      size: 'large'
    }
  }
);
